import React, { Component } from 'react';
import IntlMessages from 'lngProvider/IntlMessages';
import userService from 'services/UserService';
import ComponentContainer from 'containers/ComponentContainer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import 'extensions/urlSearchParamsExtensions';

const ConfirmProviderEmail = (props) => {
    const { data } = props;
    var emailWasValid = data.emailWasValid;

    return (
        <ComponentContainer>
            {(props) => {
                return (
                    <div>
                        {emailWasValid === true
                            ?
                            <div>
                                <h1><CheckCircleIcon fontSize="inherit" className="text-success" /><IntlMessages id="confirmEmail.confirmed" /></h1><hr />
                                <p><IntlMessages id="confirmEmail.signingIn" /></p>
                            </div>
                            :
                            <div>
                                <h1><ErrorIcon fontSize="inherit" className="text-danger" /><IntlMessages id="confirmEmail.problem" /></h1>
                                <p dangerouslySetInnerHTML={{ __html: props.intl.formatMessage({ id: "confirmEmail.contact" }) }} />
                            </div>
                        }
                    </div>
                );
            }}
        </ComponentContainer>
    );
}

export default class ConfirmProviderEmailWrapper extends Component {
    state = {
        loading: true,
        emailWasValid: false
    };

    render() {
        return (
            <ComponentContainer loading={this.state.loading}>
                <ConfirmProviderEmail data={this.state} />
            </ComponentContainer>
        );
    }

    componentDidMount() {
        var queryString = this.props.search;
        if (queryString) {
            // do not encode this query string, it breaks registration
            let searchParams = new URLSearchParams(queryString);
            var userId = searchParams.getIgnoreCase('email');
            var code = searchParams.getIgnoreCase('code');
            var returnUrl = decodeURIComponent(searchParams.getIgnoreCase('returnUrl'));
            var provider = searchParams.getIgnoreCase('provider');
            var id = searchParams.getIgnoreCase('id');

            userService
                .confirmProviderEmail(userId, code, returnUrl, provider, id)
                .then((validatedReturnUrl) => {
                    this.setState({ emailWasValid: true });
                    this.redirect(validatedReturnUrl);
                })
                .catch(() => {
                    this.setState({ emailWasValid: false });
                })
                .finally(() => this.setState({ loading: false }));
        }
    }

    redirect = (validatedReturnUrl) => {
        setTimeout(function () {
            window.location.replace(validatedReturnUrl);
        }, 3000);
    }
}
